import map from './map';
import zones from './zones';

export default {
  namespaced: true,
  modules: {
    map,
    zones,
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/maps/index.js